module.exports = __webpack_public_path__ + "img/avatar-ptt.b4a75711.png";